import axios from "axios";
import config from "config";
import { isArray } from "lodash-es";
import { i18nService } from "services/i18n/I18nService";
import {
  INewsletterAPIData,
  INewsletterSubmitData,
  NewsletterMessageType,
} from "types";

const NEWSLETTER_API_MESSAGES = {
  general: i18nService.copy["newsletter.successGeneral"],
  success: i18nService.copy["newsletter.success"],
  already_subscribed: i18nService.copy["newsletter.already_subscribed"],
};

interface INewsletterAPIResponseItem {
  id: string;
  message: "success" | "already_subscribed";
  status: 200 | 400;
}

export class NewsletterService {
  static subscribe = (
    data: INewsletterSubmitData
  ): Promise<INewsletterAPIData> =>
    new Promise(async (resolve, reject) => {
      try {
        const response = await axios({
          url: config.API.NEWSLETTER,
          method: "post",
          data: {
            ...data,
            langcode: i18nService.currentLanguage,
            source: window.location.href,
          },
        });

        const responseData: INewsletterAPIResponseItem[] = response?.data;

        // if the API says OK
        // but doesn't send an array with IDs/messages
        // just show a fallback message
        if (!isArray(responseData)) {
          resolve({
            successMessage: NEWSLETTER_API_MESSAGES.general,
          });
        }

        // get all newsletters
        // where subscription is OK
        const successCodes = responseData
          ?.filter((item) => item.message === NewsletterMessageType.success)
          ?.map((item) => item.id);

        // get all newsletters
        // where subscription is NOT OK
        const errorCodes = responseData
          ?.filter(
            (item) => item.message === NewsletterMessageType.already_subscribed
          )
          ?.map((item) => item.id);

        resolve({
          successCodes,
          successMessage: successCodes?.length
            ? NEWSLETTER_API_MESSAGES.success
            : null,
          errorCodes,
          error: errorCodes?.length
            ? NEWSLETTER_API_MESSAGES.already_subscribed
            : null,
        });
      } catch (error) {
        reject({
          error:
            error?.response?.data?.message ||
            i18nService.copy["newsletter.error"],
        });
      }
    });
}
